import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

import { LoginPage } from '../login/login';
import { AddressPage } from '../address/address';

import { Customer } from '../../models/customer';
import { Address } from '../../models/address';
import { PageBase } from '../page-base';
import { LoginProvider } from '../../providers/login/login';
import { AccountProvider } from '../../providers/account/account';
import { AddressProvider } from '../../providers/address/address';
import { MyOrdersPage } from '../my-orders/my-orders';

@IonicPage()
@Component({
  selector: 'page-account',
  templateUrl: 'account.html',
})
export class AccountPage extends PageBase {

  customer: Customer;
  addresses: Array<Address>

  selectedAddressType = 'DELIVERY';

  constructor(private loginProvider: LoginProvider, 
    private accountProvider: AccountProvider, 
    private navCtrl: NavController,
    private addressProvider: AddressProvider) {

    super();

    this.accountProvider.getAccount().then(customer => {
      this.customer = customer;
      this.addresses = customer.contact_details.addresses;
    });
  }

  /**
  * Shows action sheet to change the language.
  */
  changeLanguage() {
    this.alertProvider.languageActionSheet((lang) => {
      // Use selected language
      this.translate.use(lang);
      // Update prefered language in account
      this.customer.prefered_language = lang;
      this.accountProvider.updateAccount(this.customer);
    });
  }

  /**
  * Opens the page to add a new address.
  */
  addAddress() {
    var a = new Address();
    this.addresses.push(a);
    this.editAddress(a);
  }

  /**
  * Removes the specified address from the user addresses
  */
  removeAddress(item: Address) {
    // Filter address from list
    this.addresses = this.addresses.filter(x => x != item);
    // Remove address in database
    this.addressProvider.deleteAddress(item.uuid, this.customer.contact_details.uuid);
    // Reload address
    this.accountProvider.getAccount().then(x => this.addresses = x.contact_details.addresses);
  }

  leftView = false;
  ionViewWillEnter() {
    if (this.leftView) {
      // If not first enter of view, reload addresses.
      this.accountProvider.getAccount().then(x => this.addresses = x.contact_details.addresses);
    }
  }

  /**
  * Logs out the user, and navigates to the Login page.
  */
  logout() {
    this.loginProvider.logout();
  }

  /**
  * Navigates to the Orders page.
  */
  seeOrders() {
    this.navCtrl.push(MyOrdersPage);
  }

  /**
  * Shows an alert in which the user can change his first and last name.
  * Updates the customer if user not clicked 'cancel'.
  */
  editName() {
    this.alertProvider.showCustomerNamePrompt(this.customer.first_name, this.customer.last_name, (data) => {
      this.customer.first_name = data.first;
      this.customer.last_name = data.last;
      // Update changes in database
      this.accountProvider.updateAccount(this.customer);
    });
  }

  /**
  * Shows an alert in which the user can change his phone number.
  * Updates the customer if user not clicked 'cancel'.
  */
  editPhone() {
    this.alertProvider.showCustomerPhonePrompt(this.customer.contact_details.phone, (data) => {
      this.customer.contact_details.phone = data.phone;
      // Update changes in database
      this.accountProvider.updateAccount(this.customer);
    });
  }

  /**
  * Shows an alert in which the user can change his email address.
  * Updates the customer if user not clicked 'cancel'.
  */
  editMail() {
    this.alertProvider.showCustomerMailPrompt(this.customer.contact_details.mail, (data) => {
      this.customer.contact_details.mail = data.mail;
      // Update changes in database
      this.accountProvider.updateAccount(this.customer);
    });
  }

  /**
  * Navigates to the address page to edit address details
  * Updates the local saved addresses.
  */
  editAddress(address: Address) {
    this.leftView = true;
    // Show AddressPage
    this.navCtrl.push(AddressPage, { 'address': address, 'contactDetailsId': this.customer.contact_details.uuid });
  }
}


// WEBPACK FOOTER //
// ./src/pages/account/account.ts